import Icon from "./IconBase.js";

const EditSmallIcon = (props) => {
  return (
    <Icon width="20" height="20" viewBox="0 0 20 20" {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7187_22899)">
          <path
            d="M9.16699 3.33398H3.33366C2.89163 3.33398 2.46771 3.50958 2.15515 3.82214C1.84259 4.1347 1.66699 4.55862 1.66699 5.00065V16.6673C1.66699 17.1093 1.84259 17.5333 2.15515 17.8458C2.46771 18.1584 2.89163 18.334 3.33366 18.334H15.0003C15.4424 18.334 15.8663 18.1584 16.1788 17.8458C16.4914 17.5333 16.667 17.1093 16.667 16.6673V10.834"
            stroke="#00B0F5"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.417 2.08417C15.7485 1.75265 16.1982 1.56641 16.667 1.56641C17.1358 1.56641 17.5855 1.75265 17.917 2.08417C18.2485 2.41569 18.4348 2.86533 18.4348 3.33417C18.4348 3.80301 18.2485 4.25265 17.917 4.58417L10.0003 12.5008L6.66699 13.3342L7.50033 10.0008L15.417 2.08417Z"
            stroke="#00B0F5"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7187_22899">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};

export default EditSmallIcon;
